import { nextTick } from "vue";

export default {
    name: 'TokenLogin',

    data() {
        return {
            loading: true
        }
    },

    methods: {
        async loginWithToken() {
            this.loading = true

            try {
                const reqData = this.$route.params

                const response = await this.ApiRequest.requestAsync(
                    'token/login',
                    this.ApiRequest.REQUEST_POST,
                    reqData,
                    'login-token',
                    false
                )

                if (response.validationErrors) {
                    this.error = response.validationErrors
                    return
                }

                const { token, user } = response.data

                // auth
                this.$store.commit('setToken', token)
                sessionStorage.setItem('name', user.name)
                sessionStorage.setItem('email', user.email)

                ;(user.user_columns_filter || []).forEach((row) => {
                    if (row.columnVisibility) {
                        localStorage.setItem(`${row.section}-columns`, JSON.stringify(row.columnVisibility))
                    }

                    localStorage.setItem(`${row.section}-page-size`, JSON.stringify(row.page_size))
                })

                await this.$store.dispatch('checkPermission')
                await nextTick()
                await this.$router.push('/billing/balance')

            } catch (e) {
                console.error('Token login failed:', e)
            } finally {
                this.loading = false
            }
        }
    },

    beforeMount() {
        this.loginWithToken()
    }
}